<template><div><h1>VUX V2.2.1Rc.7 released</h1>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] Fix popup-picker filter issue on v2.2.1-rc.6</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.7 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.7-96.vue?06623496